module.exports = __webpack_public_path__ + "static/media/avatar-smile.0f7a4645.JPG";